import { IAppConfigDataModel } from '../../data-models/app-config.data-model';
import { MaggieHttp } from '../MaggieHttp';

export async function fetchAppConfig() {
  // The boot scope leaves out the KPI, rubric, share-class and financial config, which the app reads elsewhere.
  const response = await MaggieHttp.maggie.get<IAppConfigDataModel>('/configuration', {
    params: { scope: 'boot' },
  });

  return response.data;
}
